var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCisLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_317)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0 0.799988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_401_317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.999 14.4666L24.8324 6.6333L30.3324 10.7166L28.3324 14.55L17.999 14.4666Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 14.4612L19.1756 6.3208L26.9162 9.24074L23.4857 14.5497L15.833 14.4612Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83301 18.1308H5.83301V21.1308H6.83301V18.1308Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6689 14.7974L24.3356 5.96409C24.419 5.79742 24.669 5.79742 24.8356 5.88076L31.0856 10.5474C31.2523 10.6308 31.2523 10.8808 31.169 11.0474L28.3356 14.6308C28.2523 14.7141 28.169 14.7974 28.0856 14.7974H27.3356L29.0023 12.5474C28.0856 11.8808 27.8356 10.5474 28.5856 9.54743L26.419 7.88076C26.2523 7.79742 26.0856 7.79742 26.0023 7.96409C25.419 8.46409 24.5856 8.63076 23.919 8.29742C23.7523 8.21409 23.5856 8.21409 23.5023 8.38076L18.7523 14.7141C18.6689 14.7974 18.5856 14.8808 18.5023 14.8808H17.6689V14.7974Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0023 14.7974C21.0023 14.6307 21.0023 14.464 21.0856 14.2974L20.6689 13.964L21.0023 13.5474L21.4189 13.8807C21.5856 13.714 21.8356 13.6307 22.0023 13.6307C22.2523 13.6307 22.5023 13.714 22.6689 13.8807C22.6689 13.8807 22.6689 13.8807 22.7523 13.964L22.4189 14.3807C22.3356 14.2974 22.1689 14.2974 22.0856 14.2974C22.0023 14.2974 21.8356 14.3807 21.7523 14.464C21.6689 14.6307 21.5856 14.714 21.6689 14.8807H23.0023L23.1689 14.7974C23.4189 14.714 23.5856 14.714 23.7523 14.7974C23.8356 14.7974 23.8356 14.8807 23.9189 14.8807H25.3356C25.2523 14.214 24.9189 13.6307 24.3356 13.1307C23.1689 12.2974 21.5023 12.464 20.6689 13.6307C20.4189 13.964 20.2523 14.3807 20.1689 14.7974H21.0023Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24902 34.6281H13.749V35.3781C13.749 35.6281 13.499 35.8781 13.249 35.8781H9.74902C9.49902 35.8781 9.24902 35.6281 9.24902 35.3781V34.6281V34.6281Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 13.3833L15.9167 13.4667C15.75 14.05 15.25 14.55 15.1667 14.8H9.33334H9.08334V15.05V33.05V33.3H9.33334H33.3334H33.5834V33.05V15.05V14.8H33.3334H28.1693C29.1693 13.4667 28.9388 13.7948 29.375 13.3H32.7501C33.8334 13.3 34.7501 14.2167 34.7501 15.3V32.4667C34.7501 33.7167 33.7501 34.7167 32.5001 34.7167H8.25C7.16667 34.7167 6.25 33.8 6.25 32.7167V30.4667H7.33334V26.3H6.25V21.7167H7.33334V17.55H6.25V15.3833C6.25 14.2167 7.08334 13.3833 8.25 13.3833Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6634 17.8V19.9666C25.4967 19.9666 25.4134 19.9666 25.2467 19.9666C25.0801 19.9666 24.9134 19.9666 24.8301 19.9666V17.8C24.8301 17.2166 25.6634 17.2166 25.6634 17.8Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9997 15.2987H9.58301V32.7987H32.9997V15.2987Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.252 34.6281H31.752V35.3781C31.752 35.6281 31.502 35.8781 31.252 35.8781H27.752C27.502 35.8781 27.252 35.6281 27.252 35.3781V34.6281Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83301 26.8808H5.83301V29.8808H6.83301V26.8808Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3333 27.6333L27.5 26.55C27.5833 26.4667 27.6667 26.3 27.75 26.2167C27.8333 26.05 27.9167 25.9667 27.9167 25.8L29.75 26.8833C30.25 27.2167 29.8333 27.9667 29.3333 27.6333Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2497 20.3833C27.333 20.3833 28.9163 22.05 28.9163 24.05C28.9163 26.05 27.2497 27.7167 25.2497 27.7167C23.2497 27.7167 21.583 26.05 21.583 24.05C21.583 22.05 23.2497 20.3833 25.2497 20.3833Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2494 21.7115C26.5827 21.7115 27.5827 22.7948 27.5827 24.0448C27.5827 25.3781 26.4994 26.3781 25.2494 26.3781C23.916 26.3781 22.916 25.2948 22.916 24.0448C22.916 22.7115 23.916 21.7115 25.2494 21.7115Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 21.6003L27.9167 22.6836C27.8333 22.5169 27.8333 22.4336 27.75 22.2669C27.6667 22.1003 27.5833 22.0169 27.5 21.9336L29.3333 20.8503C29.8333 20.6003 30.25 21.3503 29.75 21.6003Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5818 20.8503L22.4152 21.9336C22.3318 22.0169 22.2485 22.1836 22.1652 22.2669C22.0818 22.4336 21.9985 22.5169 21.9985 22.6836L20.1652 21.6003C19.6652 21.3503 20.0818 20.6003 20.5818 20.8503Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2511 26.8833L22.0844 25.8C22.1678 25.9667 22.1678 26.05 22.2511 26.2167C22.3344 26.3833 22.4178 26.4667 22.5011 26.55L20.6678 27.6333C20.1678 27.9667 19.7511 27.2167 20.2511 26.8833Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8301 29.7961V27.6294C24.9967 27.6294 25.0801 27.6294 25.2467 27.6294C25.4134 27.6294 25.5801 27.6294 25.6634 27.6294V29.7961C25.6634 30.3794 24.8301 30.3794 24.8301 29.7961Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6634 18.2948V20.4614C25.4967 20.4614 25.4134 20.4614 25.2467 20.4614C25.0801 20.4614 24.9134 20.4614 24.8301 20.4614V18.2948C24.8301 17.7114 25.6634 17.7114 25.6634 18.2948Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0824 14.7974H32.5824C32.9991 14.7974 33.4157 15.1307 33.4157 15.6307V32.2974C33.4157 32.714 33.0824 33.1307 32.5824 33.1307H10.0824C9.66569 33.1307 9.24902 32.7974 9.24902 32.2974V15.6307C9.33236 15.214 9.66569 14.7974 10.0824 14.7974Z",
    stroke: "#F78670",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2471 14.1062L18.7471 6.1985C18.8304 6.04495 18.9971 5.96818 19.1637 6.04495L23.1638 7.58042L22.6638 8.11784L21.1637 7.58042C20.9971 7.50365 20.8304 7.58042 20.7471 7.73397C20.3304 8.34816 19.5804 8.65526 18.8304 8.50171C18.6637 8.50171 18.4971 8.50171 18.4971 8.65526L16.0804 14.1062L15.9971 14.183H15.2471V14.1062Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 17.7987H6.91634C6.99968 17.7987 7.08301 17.882 7.08301 17.9653V21.2987C7.08301 21.382 6.99968 21.4653 6.91634 21.4653H5.83301",
    stroke: "#02475E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 26.5487H6.91634C6.99968 26.5487 7.08301 26.632 7.08301 26.7153V30.0487C7.08301 30.132 6.99968 30.2153 6.91634 30.2153H5.83301",
    stroke: "#02475E",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.799988)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_401_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9167,
    height: 30.0833,
    fill: "white",
    transform: "translate(5.83301 5.79999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCisLogo);
export default __webpack_public_path__ + "static/media/CISLogo.b6b177302fbcfae5cf984c6d89a4dac6.svg";
export { ForwardRef as ReactComponent };